import { lazy } from 'react';

/**
 * 화면을 처음 열 때 불러오는 조각(chunk).
 *
 * 앱 전체가 한 파일(1.6MB)이라, 공유 화면 하나를 열 때도 통계 차트까지 모두 읽고 실행한
 * 뒤에야 첫 화면이 떴다. 무거운 화면은 실제로 들어갈 때 불러온다.
 *
 * 나눠 두면 생기는 문제가 하나 있다. 앱을 열어 둔 채 새 버전이 배포되면, 열려 있는 옛 화면이
 * 찾는 조각 파일은 이미 사라졌다. 그때는 한 번만 새로 고쳐 새 버전을 받는다
 * (보던 화면·초안은 utils/lastScreen, utils/recordDrafts 가 지킨다). 새로 고친 뒤에도
 * 실패하면 오프라인 같은 다른 이유이므로 오류를 그대로 올린다.
 */
const RELOAD_KEY = 'br_chunk_reload_at';
const RELOAD_GUARD_MS = 30 * 1000;

/**
 * @param {() => Promise<any>} importer
 * @param {{ storage?: Storage, reload?: () => void, now?: () => number }} deps 테스트용
 */
export const importWithReload = async (importer, {
  storage = sessionStorage,
  reload = () => window.location.reload(),
  now = Date.now
} = {}) => {
  try {
    return await importer();
  } catch (error) {
    let last = 0; // 0 = 아직 새로 고친 적 없음
    try { last = Number(storage.getItem(RELOAD_KEY)) || 0; } catch { /* 무시 */ }
    if (last && now() - last < RELOAD_GUARD_MS) throw error;

    try { storage.setItem(RELOAD_KEY, String(now())); } catch { /* 무시 */ }
    reload();
    // 새로 고치는 동안 빈 화면이 아니라 불러오는 중으로 둔다
    return new Promise(() => {});
  }
};

export const lazyPage = (importer) => lazy(() => importWithReload(importer));
